import store from "../init/store.js";
import { getRandomLoadout } from "../Fixture_combatants.js";
import CombatantModel from "./models/CombatantModel.js";

export function getQuickBattleScenario(controlledCombatantIds) {
  //Get a copy of my crew from state
  const crewMembers = store.getState().crew.members;
  //NOTE: These should have attacks and items included (loadouts merged in).

  //Set up the delivery object
  let payload = {};

  //Fill in each of our known controlled ids with a model from the crew.
  controlledCombatantIds.forEach((id, index) => {
    payload[id] = CombatantModel({
      ...crewMembers[Object.keys(crewMembers)[index]],
      wantsToJoinTeam: "one"
    });

    //Boost the human player's main character in speed. (Note: Quick Battle only!)
    if (index === 0) {
      payload[id].speedModifier = 13;
    }
  });

  //Get three random enemy loadouts.
  ["enemyA", "enemyB", "enemyC"].forEach((id, index) => {
    payload[id] = CombatantModel({
      ...getRandomLoadout(),
      wantsToJoinTeam: "two",
      isBot: true,
      arenaPosition: index + 1
    });
  });

  return payload;
}



// WEBPACK FOOTER //
// ./src/battle/getQuickBattleScenario.js